import { User } from '@adsk/alloy-provider';

import { useTranslation } from '../i18n';

export const sortUsersAlphabetically = (items: User[]) =>
  items.sort((a, b) => a.name.localeCompare(b.name));

export type UserOptionSubtextRenderer = (user: User) => string;
export type IdToNameMap = Record<string, string>;
type LocaleReturnType = ReturnType<typeof useTranslation>['t'];

export const getRolesStr = (
  roleIds: string[] | undefined,
  roleIdToNameMap: IdToNameMap | undefined,
  t: LocaleReturnType,
) => {
  const roleNames =
    roleIds?.map((id) => roleIdToNameMap?.[id]).filter(Boolean) || [];

  if (roleNames.length <= 1) return roleNames.join();

  const lastRole = roleNames.at(-1);
  const remainingRoles = roleNames.slice(0, -1);
  return `${remainingRoles.join(', ')} ${t('AND')} ${lastRole}`;
};

export const getSubTitleString = (
  user: User,
  companyIdToNameMap: IdToNameMap,
  roleIdToNameMap: IdToNameMap,
  t: LocaleReturnType,
): string => {
  const { roleIds, companyId } = user || {};
  const rolesStr = getRolesStr(roleIds, roleIdToNameMap, t);
  const companyName = companyIdToNameMap?.[companyId];

  return rolesStr && companyName
    ? `${companyName}, ${rolesStr}`
    : rolesStr || companyName || '';
};
